import { Link, NavLink } from "react-router-dom";
import { Mountain, Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/", label: "Calculator" },
  { to: "/guides", label: "Guides" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Logo = () => (
  <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-[0_4px_14px_rgba(37,99,235,0.35)]">
      <Mountain className="h-5 w-5" strokeWidth={2.5} />
    </span>
    <span className="font-heading text-xl font-extrabold tracking-tight text-slate-900">
      Peak<span className="text-primary">Points</span>
    </span>
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
        <Logo />

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 font-heading text-sm font-semibold transition-colors ${
                  isActive ? "text-primary" : "text-slate-600 hover:text-primary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="text-slate-900 md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-background px-6 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2 font-heading text-sm font-semibold text-slate-700 hover:bg-muted"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
